exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AdminDoctorSettingsBread[data-v-63f202c8]{margin-left:0;padding-left:4px}.AdminDoctorSettingsBread li[data-v-63f202c8]{color:#828b92;list-style:none}.AdminDoctorSettingsBread li[data-v-63f202c8]:after{content:\">\";position:relative;top:-1px;margin:0 7px;font-size:12px}.AdminDoctorSettingsBread li[data-v-63f202c8]:last-child:after{content:\"\";margin:0}", ""]);

// exports
